import React, {PureComponent, useState} from "react";
import OrderForm from "./forms/OrderForm/OrderForm";
import {connect} from "react-redux";
import {fetchDictionary} from "../../core/actions/DictionaryActions";
import {fetchPayments} from "../../core/actions/PaymentActions";
import {getUser} from "../../core/actions/UserActions";
import UrlModal from "../../core/components/modals/file/UrlModal";
import FileModal from "../../core/components/modals/file/FileModal";
import InstructionModal from "../../core/components/modals/file/InstructionModal";
import FileUploader from "../../core/components/uploader/FileUploader";
import UrlUploader from "../../core/components/uploader/UrlUploader";
import {getDeadlineItem} from "./helpers/DeadlineHelper";
import {withTranslation} from "react-i18next";
import Preloader from "./preloader/preloader";
import {siteSetData} from "../../core/actions/SiteActions";
import axios from "axios";
import {preloaderHide, preloaderShow} from "../actions/PreloaderActions";
import {getHeaders} from "../../core/xhrRequest";
import {openPage} from "../actions/PageActions";
import {PAGE_FILES} from "../constants/PageConstant";
import {modalClose} from "../../core/actions/ModalActions";
import {fetchCountryIsoCode} from "../../core/actions/CountryActions";
import {FILE_STATUS_UPLOADED} from "../../core/constants/FileStatusConstant";
import useCookieValue from "../../core/helpers/CookiesHelper";
import SlackService from "../../../../common/services/SlackService";
import ChromeModal from "../../core/components/modals/file/ChromeModal";
import MozillaModal from "../../core/components/modals/file/MozillaModal";

class Index extends PureComponent {

    componentDidMount() {
        const {fetchDictionary, fetchPayments, getUser, fetchCountryIsoCode} = this.props;
        fetchDictionary();
        fetchPayments();
        getUser();
        fetchCountryIsoCode();
        this.siteData();
    }

    siteData = () => {
        const {siteSetData} = this.props;
        const dataset = window.rootElement.dataset;

        siteSetData({
            lang: dataset.lang,
            socialAuthStatusGoogle: dataset.socialAuthStatusGoogle,
            socialAuthStatus: dataset.socialAuthStatus || false,
            facebookAppId: dataset.facebookAppId,
            googleAppId: dataset.googleAppId,
        });
    };

    setUser = () => {
        const {setUser, cookies} = this.props;

        setUser({
            email: cookies.get('email'),
            name: cookies.get('name'),
            phone: cookies.get('phone'),
            timezone: cookies.get('timezone'),
        })
    };

    handleSubmit = values => {
        const {user, fileItems, preloaderShow, deadlines} = this.props;

        const form = new FormData();
        form.append('order[service]', values.service);
        form.append('order[coupon]', values.coupon);
        form.append('order[rush]', values.rush ? 1 : 0);
        form.append('order[timestamp]', values.timestamp ? 1 : 0);
        form.append('order[verbatim]', values.verbatim ? 1 : 0);
        form.append('paymentMethod', values.paymentMethod);
        form.append('email', user.email);

        fileItems.map((file, index) => {
            if (file.status === FILE_STATUS_UPLOADED) {
                const deadline = getDeadlineItem(values.service, deadlines, file);

                form.append(`files[${index}][name]`, file.name);
                form.append(`files[${index}][originalName]`, file.originalName);
                form.append(`files[${index}][deadline]`, deadline.deadline);
            }
        });

        preloaderShow();
        axios.post('/api/order', form, {headers: getHeaders(), timeout: 60000})
            .then(response => {
                if (typeof response.data === 'string') {
                    location.href = response.data
                } else {
                    location.reload();
                    let path = '*Front/Transcription/js/form/components/Index* - call *handleSubmit.then()*'
                    let message = SlackService.prepareData(path, response);
                    SlackService.send(message);
                }
            })
            .catch(error => {
                console.log(error);
                preloaderHide();
                location.href = error.response.data.redirectTo;
                let path = '*Front/Transcription/js/form/components/Index* - call *handleSubmit.catch()*'
                let message = SlackService.prepareData(path, error);
                SlackService.send(message);
            });
    };

    openFilesPage = () => {
        this.props.openPage(PAGE_FILES);
    }

    render() {
        const {defaultPaymentMethod, services} = this.props;
        const referralCoupon = useCookieValue('referral_coupon');

        return <div className="wrapper-holder">
            <div className="main-area">
                <OrderForm
                    onSubmit={this.handleSubmit}
                    initialValues={{
                        service: services.length ? services[0].value : undefined,
                        paymentMethod: defaultPaymentMethod,
                        currency: 'usd',
                        coupon: referralCoupon,
                    }}
                />
            </div>
            <UrlModal id="url-modal-component" finishCallback={this.openFilesPage}/>
            <FileModal id="file-modal-component" finishCallback={this.openFilesPage}/>
            <InstructionModal id="instruction-modal-component" finishCallback={this.openFilesPage}/>
            <ChromeModal id="chrome-modal-component" finishCallback={this.openFilesPage}/>
            <MozillaModal id="mozilla-modal-component" finishCallback={this.openFilesPage}/>
            <FileUploader/>
            <UrlUploader/>
            <Preloader/>
        </div>;
    }
}

Index = withTranslation()(Index);

export default connect(
    state => ({
        fileItems: state.file.files,
        deadlines: state.dictionary.deadline,
        phoneCodes: state.dictionary.phoneCodes,
        services: state.dictionary.service,
        user: state.user,
        countryCode: state.country.code,
        payments: state.payment.payments,
        defaultPaymentMethod: state.payment.defaultPaymentMethod,
        dependencies: state.dictionary.dependencies,
    }),
    dispatch => ({
        fetchDictionary: () => dispatch(fetchDictionary()),
        fetchPayments: () => dispatch(fetchPayments()),
        getUser: () => dispatch(getUser()),
        siteSetData: data => dispatch(siteSetData(data)),
        fetchCountryIsoCode: () => dispatch(fetchCountryIsoCode()),
        preloaderShow: () => dispatch(preloaderShow()),
        preloaderHide: () => dispatch(preloaderHide()),
        modalClose: id => dispatch(modalClose(id)),
        openPage: page => dispatch(openPage(page)),
    }),
)(Index)